import { Controller, get } from "react-hook-form";
import { RichTextEditor } from "../../ui";

export interface InputDescricaoProps {
  name: string;
  label?: string;
  methods: any;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  minHeight?: number;
}

export default function InputDescricao({
  name,
  label = "Descrição",
  methods,
  placeholder,
  disabled,
  required,
  minHeight,
}: InputDescricaoProps) {
  return (
    <Controller
      name={name}
      control={methods.control}
      defaultValue=""
      render={({ field, formState: { errors } }) => {
        const error = get(errors, name);
        return (
          <RichTextEditor
            value={field.value || ""}
            onChange={field.onChange}
            onBlur={field.onBlur}
            label={label}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            minHeight={minHeight}
            error={!!error}
            helperText={error?.message}
          />
        );
      }}
    />
  );
}
